import React from "react";
import {Button, Card, Divider} from "antd";
import { useAuth } from "../../context/AuthContext";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./MentionsLegalesPage.css";
import { ROUTES } from "../../Routes/Routes";

const MentionsLegalesPage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="terms-page">
            <Card className="terms-card" bordered>
                <div className="terms-header">
                    <img src={logo} alt="Logo UAMA" className="terms-logo" />
                    <h1 className="terms-title">Mentions Légales</h1>
                    {user && (
                        <p className="terms-greeting">
                            Bonjour <strong>{user["Nom complet"]}</strong>, voici les informations légales du site UAMA.
                        </p>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", width: "100%", marginTop: "2vh" }}>
                        <p style={{ margin: 0 }}><strong>Date de publication : </strong>avril 2025</p>
                    </div>
                </div>

                <Divider />

                <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                    <div className="terms-section">
                        <h2>Éditeur du site</h2>
                        <p>
                            Ce site est édité par <strong>Grégory, Maxime, Vincent et Thibaud</strong>, à titre personnel, dans un cadre non commercial.
                            <br />
                            Projet <strong>UAMA</strong> – Outil d'aide à la gestion pour assistante maternelle.
                            <br />
                            Cette plateforme a été développée dans le cadre d’un projet d'études.
                            Le projet visait à répondre à un besoin réel identifié auprès d’une assistante maternelle.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>Contact</h2>
                        <p>
                            Vous pouvez me contacter par email à : <strong>thibaud_dufour[at]icloud.com</strong> (remplacer [at] par @)
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>Hébergement</h2>
                        <p>
                            Le site est hébergé sur un serveur privé à domicile.
                            <br />
                            Zone DNS gérée par <strong>OVH</strong> – 2 rue Kellermann, 59100 Roubaix, France.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>Utilisation des données</h2>
                        <p>
                            Les données affichées et utilisées sont strictement nécessaires au bon fonctionnement de l'application.
                            <br />
                            Aucune donnée personnelle n’est collectée ni transmise à des tiers à des fins commerciales.
                            <br />
                            Certaines informations sont temporairement stockées dans le navigateur (localStorage) pour améliorer l'expérience utilisateur.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>Propriété intellectuelle</h2>
                        <p>
                            L'ensemble du code, des interfaces et du contenu de l'application UAMA est protégé par le droit d’auteur.
                            <br />
                            Ce projet a été réalisé collectivement dans le cadre d’un exercice pédagogique. Toute réutilisation ou reproduction sans autorisation préalable est interdite.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>Responsabilité</h2>
                        <p>
                            Le site est fourni à titre informatif. L’éditeur ne saurait être tenu responsable d’un usage incorrect de la plateforme.
                        </p>
                    </div>
                </div>

                <Divider />

                <Button type="primary" block icon={<LeftOutlined/>} onClick={() => navigate(ROUTES.HOME)}>
                    Retour à l'accueil
                </Button>
            </Card>
        </div>
    );
};

export default MentionsLegalesPage;
